export enum AgreementType {
  DE = "DE", //Devis
  CP = "CP", //Contrat
}
